export interface FontFamily {
  displayName?: string;
  styleName: string;
  fontFamily: string;
}

export const defaultFontList: FontFamily[] = [
  { displayName: 'Arial', styleName: 'arial', fontFamily: 'Arial, sans-serif' },
  {
    displayName: 'Courier New',
    styleName: 'courier_new',
    fontFamily: 'Courier New, monospace',
  },
  {
    displayName: 'Georgia',
    styleName: 'georgia',
    fontFamily: 'Georgia, serif',
  },
  {
    displayName: 'Impact',
    styleName: 'impact',
    fontFamily: 'Impact, sans-serif',
  },
  {
    displayName: 'Inter',
    styleName: 'sans-serif', // This is the default font name stored in existing documents, so we keep it for backward compatibility.
    fontFamily: 'Inter, sans-serif',
  },
  { displayName: 'Lato', styleName: 'lato', fontFamily: 'Lato, sans-serif' },
  {
    displayName: 'Montserrat',
    styleName: 'montserrat',
    fontFamily: 'Montserrat, sans-serif',
  },
  {
    displayName: 'Noto Sans',
    styleName: 'noto_sans',
    fontFamily: 'Noto Sans, sans-serif',
  },
  {
    displayName: 'Open Sans',
    styleName: 'open_sans',
    fontFamily: 'Open Sans, sans-serif',
  },
  {
    displayName: 'Quicksand',
    styleName: 'quicksand',
    fontFamily: 'Quicksand, sans-serif',
  },
  { displayName: 'Rubik', styleName: 'rubik', fontFamily: 'Rubik, sans-serif' },
  {
    displayName: 'Roboto',
    styleName: 'roboto',
    fontFamily: 'Roboto, sans-serif',
  },
  {
    displayName: 'Shadows Into Light',
    styleName: 'shadows_into_light',
    fontFamily: 'Shadows Into Light, sans-serif',
  },
  {
    displayName: 'Times New Roman',
    styleName: 'times_new_roman',
    fontFamily: 'Times New Roman, Times, serif',
  },
  {
    displayName: 'Trebuchet MS',
    styleName: 'trebuchet_ms',
    fontFamily: 'Trebuchet MS, sans-serif',
  },
  {
    displayName: 'Verdana',
    styleName: 'verdana',
    fontFamily: 'Verdana, Geneva, sans-serif',
  },
];
